import { render } from "./CartHeaderUom.vue?vue&type=template&id=38769484"
import script from "./CartHeaderUom.vue?vue&type=script&lang=js"
export * from "./CartHeaderUom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__